import { render, staticRenderFns } from "./Kariera.vue?vue&type=template&id=baadfc50&scoped=true&"
import script from "./Kariera.vue?vue&type=script&lang=js&"
export * from "./Kariera.vue?vue&type=script&lang=js&"
import style0 from "./Kariera.vue?vue&type=style&index=0&id=baadfc50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baadfc50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\4g22\\themes\\foreground-theme-2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('baadfc50')) {
      api.createRecord('baadfc50', component.options)
    } else {
      api.reload('baadfc50', component.options)
    }
    module.hot.accept("./Kariera.vue?vue&type=template&id=baadfc50&scoped=true&", function () {
      api.rerender('baadfc50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/kariera/Kariera.vue"
export default component.exports